/* eslint-disable */
import React from "react";
import { TextField, Link } from "@material-ui/core";
import { Container, Row, Col } from "react-bootstrap";
import css from "assets/css/login.css";
import apple from "assets/img/apple.png";
import google from "assets/img/google.png";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { Button, useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { Alert } from "react-bootstrap";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import {
  auth,
  db,
} from "../Firebase/firebase.js";
import { useHistory } from "react-router-dom";
import ls from "local-storage";
import IconButton from "@material-ui/core/IconButton";

function Login() {
  let history = useHistory();
  const theme = new useTheme();
  const checkRatio = useMediaQuery(theme.breakpoints.down("sm"));
  const Ipadpro = useMediaQuery(theme.breakpoints.between("md", "1300"));
  const Laptop = useMediaQuery(theme.breakpoints.up("lg"));
  const Ipad = useMediaQuery(theme.breakpoints.between("700", "870"));
  var emailref = React.useRef("");
  var passwordref = React.useRef("");
  const emaillinkRef = React.useRef("");
  const [error, setError] = React.useState("");
  const [showpassword, setShowpassword] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [messagetype, setMessagetype] = React.useState(true);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const showPassword = (e) => {
    if (e.target.checked === true) {
      setShowpassword(true);
    } else {
      setShowpassword(false);
    }
  };


  const clickHandler = async () => {
    const Username = emailref.current.value;
    const Password = passwordref.current.value;
    await auth
      .signInWithEmailAndPassword(Username, Password)
      .then((data) => {
        ls.set("currentuser", data.user);
        db.collection("users")
          .where("uid", "==", data.user.uid)
          .where("type","!=","customer")
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              // console.log( doc.id, " => ", doc.data());
            });
            if (querySnapshot.size === 0) {
              setError("Invalid Credentials!");
              setTimeout(() => {
                setError("");
              }, 4000);
            } else {
              history.push("/admin/dashboard");
            }
          })
          .catch((error) => {
            console.log("Error getting documents: ", error);
          });
      })
      .catch((error) => {
        console.log(error);
        setError("Incorrect Credentials!");
        setTimeout(() => {
          setError("");
        }, 4000);
      });
  };

  const forgetpassword = () => {
    const email = emaillinkRef.current.value;
    db.collection("users")
      .where("email", "==", email).where("type","!=","customer")
      .get()
      .then((querySnapshot) => {
        if (querySnapshot.size === 0) {
          setError("No Account Found");
          setOpen(false);
          setTimeout(() => {
            setError("");
          }, 4000);
        } else {
          auth
            .sendPasswordResetEmail(email)
            .then(function () {
              setMessagetype(false);
              setError("Password reset link has been sent to your email");
              setTimeout(() => {
                setError("");
                setMessagetype(true);
              }, 4000);
              setOpen(false);
            })
            .catch(function (e) {
              console.log(e);
            });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  var stylee;
  if (checkRatio) {
    stylee = {
      marginLeft: checkRatio ? 50 : 200,
    };
  }
  if (Ipadpro) {
    stylee = {
      marginLeft: Ipadpro ? -20 : 200,
    };
  }
  if (Laptop) {
    stylee = {
      marginLeft: Ipadpro ? 200 : 200,
    };
  }

  return (
    <>
      <Container fluid style={{overflow:checkRatio?"hidden":null}}>
        <Row noGutters="true">
          <Col>
            <div className="panel2"></div>
            <img
              className="logo"
              src={require("assets/img/derby-logo.png")}
              alt="logo"
            ></img>
          </Col>
          <Col>
            {checkRatio ? <br></br> : null}
            <div className="Loginform ">
              <br></br>
              {checkRatio ? <br></br> : null}
              <h1 className="Header">Admin Login</h1>

              {error && (
                <Alert
                  style={{
                    marginLeft: Ipadpro ? -190 : 5,
                    width: checkRatio ? 280 : Ipadpro ? 500 : 600,
                  }}
                  variant={messagetype ? "danger" : "success"}
                >
                  {error}
                </Alert>
              )}
              <div
                className="textfield"
                style={{ marginLeft: Ipadpro ? -190 : 5 }}
              >
                <TextField
                  inputRef={emailref}
                  required
                  label="Email"
                  type="email"
                  variant="outlined"
                  style={{ width: checkRatio ? 280 : Ipadpro ? 500 : 600 }}
                />
              </div>
              <div
                className="passwordtextfield"
                style={{ marginLeft: Ipadpro ? -190 : 5 }}
              >
                <TextField
                  inputRef={passwordref}
                  required
                  label="Password"
                  type={showpassword ? "text" : "password"}
                  variant="outlined"
                  style={{ width: checkRatio ? 280 : Ipadpro ? 500 : 600 }}
                />
              </div>

              <FormControlLabel
                control={
                  <Checkbox
                    onClick={showPassword}
                    name="checkedB"
                    color="primary"
                    style={{ color: "#171942", marginLeft: Ipadpro ? -190 : 8 }}
                  />
                }
                label="Show Password"
              />
              <p
                className="forgettext"
                style={{ marginLeft: Ipadpro ? 150 : checkRatio ? 200 : 450 }}
                onClick={handleClickOpen}
              >
                Forgot password?
              </p>
              <Button
                variant="contained"
                onClick={clickHandler}
                style={{
                  backgroundColor: "#171942",
                  width: 180,
                  height: 49,
                  borderRadius: 49,
                  border: null,
                  outline: null,
                  color: "white",
                  marginLeft: checkRatio ? 50 : Ipadpro ? -20 : 200,
                  marginTop: checkRatio ? 30 : 20,
                }}
              >
                LOGIN
              </Button>
              <br></br>
              <br></br>
           
              {checkRatio ? <br></br> : null}
              {checkRatio ? <br></br> : null}
              
            </div>
          </Col>
        </Row>
      </Container>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="Prize-title"
        aria-describedby="Prize-description"
      >
        <DialogTitle id="prize-header" style={{ paddingLeft: "0" }}>
          <div>
            <IconButton onClick={handleClose}>
              <i className="fa fa-chevron-circle-left fa-lg"></i>
            </IconButton>
            <h5 style={{ display: "inline-block" }}></h5>
          </div>
        </DialogTitle>
        <DialogContent style={{ height: 100, width: 310 }}>
          <div className="prize-form">
            <TextField
              inputRef={emaillinkRef}
              required
              label="Email"
              placeholder="Enter your email"
              variant="outlined"
              style={{ marginLeft: -5, width: 280 }}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={forgetpassword}
            style={{
              marginRight: 50,
              width: 200,
              color: "white",
              backgroundColor: "#171942",
            }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
export default Login;
